module.exports = __webpack_public_path__ + "img/BB_Logotype_SingleLine_Black_CMYK.1bd666a9.png";